import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getStore = (state: AppState) => state.autoTopUp;
const getResList = (state: AppState) => state.autoTopUp.resListAutoTopUp;
const getPendingListAuto = (state: AppState) => state.autoTopUp.statusListAuto;
const getResListProvider = (state: AppState) => state.autoTopUp.resListProvider;
const getValidPhone = (state: AppState) => state.autoTopUp.responseValidPhone;
const getDataCreate = (state: AppState) => state.autoTopUp.dataCreate;
const getResponseCreated = (state: AppState) => state.autoTopUp.responseCreate;
const getResponseAuth = (state: AppState) => state.autoTopUp.responseAuth;
const getResponseTransaction = (state: AppState) => state.autoTopUp.responseTransaction;
const getPendingTransaction = (state: AppState) => state.autoTopUp.statusTransaction;

export const getAutoTopUpStoreSelector = createSelector(getStore, (data) => data);
export const getAutoTopUpListSelector = createSelector(getResList, (data) => data);
export const getAutoTopUpPendingListAutoSelector = createSelector(getPendingListAuto, (status) => status);

export const getAutoTopUpListProviderSelector = createSelector(getResListProvider, (data) => data);

export const getAutoTopUpValidPhoneSelector = createSelector(getValidPhone, (data) => data);

export const getAutoTopUpDataCreateSelector = createSelector(getDataCreate, (data) => data);

export const getAutoTopUpResCreatedSelector = createSelector(getResponseCreated, (res) => res);
export const getAutoTopUpResAuthSelector = createSelector(getResponseAuth, (res) => res);

export const getAutoTopUpResTransactionSelector = createSelector(getResponseTransaction, (res) => res);
export const getAutoTopUpPendingTransactionSelector = createSelector(getPendingTransaction, (status) => status);
